import BANKING_ADMIN from './baas'
import LOS from './los'

export default {
  ...BANKING_ADMIN,
  ...LOS,
}
